






























import OareContentView from '@/components/base/OareContentView.vue';
import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  components: { OareContentView },
  name: 'AnalyticsView',
  setup() {
    const actions = sl.get('globalActions');
    const src = ref('');
    const href = ref('');
    const loading = ref(false);

    const production = computed(() => process.env.NODE_ENV === 'production');

    onMounted(async () => {
      loading.value = true;
      try {
        if (production.value) {
          src.value = process.env.VUE_APP_GOOGLE_ANALYTICS_DASHBOARD_SOURCE;
          href.value = process.env.VUE_APP_GOOGLE_ANALYTICS_HREF;
        }
      } catch (err) {
        actions.showErrorSnackbar('Error loading dashboard', err as Error);
      } finally {
        loading.value = false;
      }
    });
    return {
      src,
      href,
      production,
      loading,
    };
  },
});
